import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {getContentVersionList, getSimilarContent} from "../api/client";
import "./Pages.css";

import {Header} from "../components/Header";
import {CenteredSpinner, CenteredSpinner2} from "../components/CenteredSpinner";
import {setQueryString} from "../slices/usersSlice";
import {Checkbox, IconStatusHelp, Modal, RadioGroup, Slider, Toggle, Tooltip} from '@seismic/mantle'
import {HumanDate} from "../components/Helpers";


export const ShowThumbnails = ({originalName, originalThumbnailUrl, thumbnails, index, showModal, setShowModal, setIndex}) => {

    if(thumbnails == null || thumbnails.length === 0)
        return null;
    const item = thumbnails[index];

    const safeSetIndex = (val) => {
        if(val < thumbnails.length && val >= 0) {
            setIndex(val)
        }
    }

    const [display, setDisplay] = useState("overlay");
    const showOriginalOnly = display === "original";
    const showOriginal = display === "original" || display === "overlay";
    const showSimilar = display === "similar" || display === "overlay";

    return <Modal
        size="lg"
        open={showModal}
        onClose={() => setShowModal(false)}
        header={`${originalName}`}
        closeOnOutsideClick
        footerButtonProps={[
            { label: '<', variant: 'secondary', onClick: () => safeSetIndex(index -1) },
            { label: `${index+1} of ${thumbnails.length}`},
            { label: '>', variant: 'secondary', onClick: () => safeSetIndex(index +1) },
            { label: 'Close', variant: 'secondary', onClick: () => setShowModal(false) }
        ]}
    >
        <div style={{width: "100%"}}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 8}}>
                <h4>{showOriginalOnly ? <>Original</> : <>{item.name} - page {item.page}</>}</h4>
                <div>
                    <span>Select Display</span>
                    <select style={{width: 200}} value={display} onChange={(e)=>setDisplay(e.target.value)}>
                        <option value="overlay">Overlay</option>
                        <option value="original">Original Only</option>
                        <option value="similar">Similar Only</option>
                    </select>
                </div>
            </div>

            <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%"}}>
                <div className="image-container">
                    {showOriginal && <img src={originalThumbnailUrl} alt={originalName} className="background-image" />}
                    {showSimilar && <img src={item.thumbnailUrl} alt={item.name} className={showOriginal ? "overlay-image" : "background-image" }/>}
                </div>
            </div>
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
                {showOriginalOnly ? <>Original</> : <><Distance showTooltip={false} distance={item.distance} />
                    aHash={item.averageHashDistance} pHash={item.perceptualHashDistance} dHash={item.differenceHashDistance} wHash={item.waveletHashDistance} cHash={item.colorHashDistance} sHash={item.simHashDistance}</>}
                <div>version {(showOriginalOnly ? 'Original' : item.version)}</div>
            </div>
        </div>
    </Modal>
}

const Distance = ({distance, averageHashDistance, perceptualHashDistance, differenceHashDistance, waveletHashDistance, colorHashDistance, simHashDistance, showTooltip}) => {
    var distanceColor = "green";
    if(distance > 20)
        distanceColor = "orange";
    if(distance > 40)
        distanceColor = "darkorange";
    if(distance > 50)
        distanceColor = "red";

    var diffs = <span style={{color: distanceColor}}>{distance} differences</span>
    if(distance == null)
        diffs = <span style={{color: "blue"}}>Original</span>

    return <div style={{display: "flex", alignItems: "center"}}>
        {diffs}
        {showTooltip && distance != null && distance > 0 && <>&nbsp;<Tooltip zIndex={4} position="bottom" size="lg" variant="light" content={<small>
            {averageHashDistance > 0 && <div style={{whiteSpace: "nowrap"}}>Average Hash Distance: {averageHashDistance}</div>}
            {perceptualHashDistance > 0 && <div style={{whiteSpace: "nowrap"}}>Perceptual Hash Distance: {perceptualHashDistance}</div>}
            {differenceHashDistance > 0 && <div style={{whiteSpace: "nowrap"}}>Difference Hash Distance: {differenceHashDistance}</div>}
            {waveletHashDistance > 0 && <div style={{whiteSpace: "nowrap"}}>Wavelet Hash Distance: {waveletHashDistance}</div>}
            {colorHashDistance > 0 && <div style={{whiteSpace: "nowrap"}}>Color Hash Distance: {colorHashDistance}</div>}
            {simHashDistance > 0 && <div style={{whiteSpace: "nowrap"}}>Sim Hash Distance: {simHashDistance}</div>}
        </small>}>
                    <span>
                        <IconStatusHelp size={16} />
                    </span>
        </Tooltip></>}
    </div>
}

export const ContentPageTile = ({showCheckmark, contentVersionId, contentId, teamsiteId, name, page, size, distance, createdAt, version, repository, createdBy, createdByEmail, thumbnailUrl, averageHashDistance, perceptualHashDistance, differenceHashDistance, waveletHashDistance, colorHashDistance, simHashDistance, setShowModal, setIndex, index}) => {
    
    const [checked, setChecked] = useState(true);
    
    return <div style={{display: "flex", flexDirection: "column", border: `1px solid ${distance == null ? "blue" : "#cfd4da"}`, borderRadius: 4, padding: "8px"}}>
        <div style={{display: "flex", justifyContent: "space-between"}}>
            <div title={name} style={{cursor: "default", fontWeight: "bold", width: 250, maxWidth: 250, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>
                {showCheckmark && <span style={{paddingRight: "4px"}}><Checkbox checked={checked} onChange={e=>setChecked(e.target.checked)} /></span>}
                <a target="_blank" href={`https://quake.seismic.com/app#/contentmanager/detail/${teamsiteId}/${contentId}/info/LIST/title?versionId=${contentVersionId}&structureId=undefined`}>
                {name}
                </a>
            </div>
            <small>page {page}</small>
        </div>
        <div style={{padding: 8}}>
            <img onClick={()=>{setShowModal && setShowModal(true);setIndex(index);}} style={{border: "1px solid #cfd4da"}} loading="lazy" width={size === "xs" ? 100 : 300} src={thumbnailUrl} alt="x" />
        </div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            <div style={{display: "flex", flexDirection: "column"}}>
                <small>{repository}</small>
                <small>v{version}</small>
            </div>
            <div>
                <Distance showTooltip={true} distance={distance} averageHashDistance={averageHashDistance} perceptualHashDistance={perceptualHashDistance} differenceHashDistance={differenceHashDistance} waveletHashDistance={waveletHashDistance} colorHashDistance={colorHashDistance} simHashDistance={simHashDistance} />
            </div>
            <div style={{display: "flex", flexDirection: "column"}}>
                <small><a href={`mailTo:${createdByEmail}`}>{createdBy}</a></small>
                <small><HumanDate date={createdAt} /></small>
            </div>
        </div>
    </div>
}

const HashSlider = ({name, value, setValue, step=1, min= -1, max=100}) => {
    return <div style={{width: 200, paddingLeft: 10}}>
        <div style={{whiteSpace: "nowrap"}}>{name} ({value ===  -1 ? "Not Used" : value === 0 ? "Exact" : value})</div>
        <Slider value={value} onChange={setValue} step={step} min={min} max={max} />
    </div>
}

const getIntValue = (urlParams, name, def) => {
    let val = urlParams.get(name);
    if(val != null)
        return parseInt(val, 10);
    return def
}

export const Pages = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const qsContentVersionId = urlParams.get('contentVersionId');
    const qsPage = urlParams.get('page');
    const qsAverageHashThreshold = getIntValue(urlParams, 'averageHashThreshold', 25)
    const qsColorHashThreshold = getIntValue(urlParams, 'colorHashThreshold', 25)
    const qsDifferenceHashThreshold = getIntValue(urlParams, 'differenceHashThreshold', 25)
    const qsPerceptualHashThreshold = getIntValue(urlParams, 'perceptualHashThreshold', 25)
    const qsWaveletHashThreshold = getIntValue(urlParams, 'waveletHashThreshold', 25)
    const qsSimHashThreshold = getIntValue(urlParams, 'simHashThreshold', 25)
    const qsMaxDistance = getIntValue(urlParams, 'maxDistance', 60)
    const qsIsDeleted = urlParams.get('isDeleted') || "false";
    const qsIsPublished = urlParams.get('isPublished') || "true";
    const qsMethod = urlParams.get('method') || "postgres_vector";
    
    const dispatch = useDispatch();
    const [contentVersionList, setContentVersionList] = useState([]);
    const [selectedContentVersionId, setSelectedContentVersionId] = useState(null);
    const [contentVersion, setContentVersion] = useState(null);
    const [selectedPage, setSelectedPage] = useState(null);
    const currentPage = ((contentVersion?.pages) ?? []).find(a=>a.page.toString() === selectedPage?.toString());
    const [similarContent, setSimilarContent] = useState([]);
    const [averageHashThreshold, setAverageHashThreshold] = useState(qsAverageHashThreshold);
    const [colorHashThreshold, setColorHashThreshold] = useState(qsColorHashThreshold);
    const [differenceHashThreshold, setDifferenceHashThreshold] = useState(qsDifferenceHashThreshold);
    const [perceptualHashThreshold, setPerceptualHashThreshold] = useState(qsPerceptualHashThreshold);
    const [waveletHashThreshold, setWaveletHashThreshold] = useState(qsWaveletHashThreshold);
    const [simHashThreshold, setSimHashThreshold] = useState(qsSimHashThreshold);
    const [maxDistance, setMaxDistance] = useState(qsMaxDistance);
    const [isDeleted, setIsDeleted] = useState(qsIsDeleted);
    const [isPublished, setIsPublished] = useState(qsIsPublished);
    const [selectedMethod, setSelectedMethod] = useState(qsMethod)
    
    const [payload, setPayload] = useState(null);
    const [index, setIndex] = useState(0);

    const [showThumbnailModal, setShowThumbnailModal] = useState(false);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        getContentVersionList(selectedMethod)
            .then(data => {
                setContentVersionList(data);
                let item = data.filter(a=>a.contentVersionId === qsContentVersionId);
                if(item.length > 0) {
                    assignContentVersion(item[0])
                    let pages = item[0].pages.filter(a=>a.page.toString() === qsPage.toString());
                    if(pages.length > 0)
                        assignSelectedPage(pages[0].page)
                    else
                        assignSelectedPage(item[0].pages[0].page)
                }
                else {
                    assignContentVersion(data[0])
                    assignSelectedPage(data[0].pages[0].page)
                }
            })
    }, []);

    const [took, setTook] = useState(0);
    
    const doIt = () => {
        if (selectedContentVersionId === null || selectedPage === null || selectedMethod === null)
            return;
        setLoading(true);
        setSimilarContent([]);
        setPayload(getPayload());
        setIndex(0);
        //measure time to get similar content
        let now = new Date();
        getSimilarContent(selectedMethod, getPayload())
            .then(data => {
                setTook(new Date() - now)
                setSimilarContent(data)
            }).finally(()=> {
            setLoading(false);
            });
    }
    
    useEffect(() => {
        doIt()
    }, [selectedContentVersionId, selectedPage, selectedMethod, isDeleted, isPublished]);
    
    const getPayload = () => {
        return {
            contentVersionId: contentVersion?.contentVersionId,
            ...contentVersion?.pages.filter(a=>a.page.toString() === selectedPage.toString())[0],
            averageHashThreshold: averageHashThreshold,
            colorHashThreshold: colorHashThreshold,
            differenceHashThreshold: differenceHashThreshold,
            perceptualHashThreshold: perceptualHashThreshold,
            waveletHashThreshold: waveletHashThreshold,
            simHashThreshold: simHashThreshold,
            maxDistance: maxDistance,
            isDeleted: isDeleted === "all" ? null : isDeleted === "true",
            isPublished: isPublished === "all" ? null : isPublished === "true"
        }
    }
    
    const signOut = () => {
        dispatch(setAccessToken(null));
    }

    const assignContentVersion = (contentVersion) => {
        setSelectedContentVersionId(contentVersion.contentVersionId);
        setContentVersion(contentVersion);
        setQueryString("contentVersionId", contentVersion.contentVersionId);
    }

    const assignSelectedPage = (page) => {
        setSelectedPage(page);
        setQueryString("page", page);
    }

    const assignIsDeleted = (val) => {
        setIsDeleted(val);
        setQueryString("isDeleted", val);
    }

    const assignIsPublished = (val) => {
        setIsPublished(val);
        setQueryString("isPublished", val);
    }
    
    const assignSelectedMethod = (val) => {
        setSelectedMethod(val);
        setQueryString("method", val);
    }

    return <>
        <ShowThumbnails originalName={contentVersion?.name} originalThumbnailUrl={currentPage?.thumbnailUrl} thumbnails={similarContent} index={index} setIndex={setIndex} showModal={showThumbnailModal} setShowModal={setShowThumbnailModal} />
        <Header signOut={signOut} title="Seismic Meetings - Pages" additionalContent={<a href="https://seismic.atlassian.net/wiki/spaces/INCENG/pages/3607887916/Content+Similarity" target="_blank">Content Similarity Documentation</a>} navigateTo="/Pages" />
        <div style={{padding: "16px"}}>
            <div style={{paddingBottom: 16, display: "flex"}}>
                <select style={{width: 500}} value={selectedContentVersionId} onChange={(e) => {
                    let item = contentVersionList.filter(a=>a.contentVersionId === e.target.value);
                    assignContentVersion(item[0])
                    assignSelectedPage(item[0].pages[0].page)
                }
                }>
                    {contentVersionList.map(item => (
                        <option key={item.contentVersionId} value={item.contentVersionId}>
                            {item.name} v{item.version} created {item.createdAt.split("T")[0]}
                        </option>
                    ))}
                </select>
                <select style={{width: 100}} value={selectedPage} onChange={(e) => {
                    assignSelectedPage(e.target.value)
                }
                }>
                    {contentVersion && contentVersion.pages.map(item => (
                        <option key={item.page} value={item.page}>
                            Page {item.page}
                        </option>
                    ))}
                </select>
                <select style={{width: 150}} value={selectedMethod} onChange={(e) => {
                    assignSelectedMethod(e.target.value)
                }
                }>
                    {/*<option value="postgres_hamming">Postgres Hamming</option>*/}
                    <option value="postgres_vector">Postgres Vector</option>
                    <option value="elastic_vector">Elastic Vector</option>
                    <option value="elastic_term">Elastic Term</option>
                </select>
                <select style={{width: 60}} value={isPublished} onChange={(e) => {
                    assignIsPublished(e.target.value)
                }
                }>
                    <option value="all">All</option>
                    <option value="true">Published</option>
                    <option value="false">Not Published</option>
                </select>
                <select style={{width: 60}} value={isDeleted} onChange={(e) => {
                    assignIsDeleted(e.target.value)
                }
                }>
                    <option value="all">All</option>
                    <option value="false">Not Deleted</option>
                    <option value="true">Deleted</option>
                </select>
                
                <button onClick={doIt}>Go</button>
                <HashSlider name="Average Hash" value={averageHashThreshold} setValue={(value) => {setAverageHashThreshold(value);setQueryString("averageHashThreshold", value);}} />
                <HashSlider name="Color Hash" value={colorHashThreshold} setValue={(value) => {setColorHashThreshold(value);setQueryString("colorHashThreshold", value);}} />
                <HashSlider name="Difference Hash" value={differenceHashThreshold} setValue={(value) => {setDifferenceHashThreshold(value);setQueryString("differenceHashThreshold", value);}} />
                <HashSlider name="Perceptual Hash" value={perceptualHashThreshold} setValue={(value) => {setPerceptualHashThreshold(value);setQueryString("perceptualHashThreshold", value);}} />
                <HashSlider name="Wavelet Hash" value={waveletHashThreshold} setValue={(value) => {setWaveletHashThreshold(value);setQueryString("waveletHashThreshold", value);}} />
                <HashSlider name="Sim Hash" value={simHashThreshold} setValue={(value) => {setSimHashThreshold(value);setQueryString("simHashThreshold", value);}} />
                <HashSlider name="Max Distance" min={0} max={600} step={5} value={maxDistance} setValue={(value) => {setMaxDistance(value);setQueryString("maxDistance", value);}} />
                
            </div>
            {false && <pre>{JSON.stringify(payload, null, 2)}</pre>}
            {contentVersion === null && <CenteredSpinner />}
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h3>Similar Content</h3>
                <small>Took {took} ms ({similarContent.length} items)</small>
            </div>
            
            {contentVersion && <div style={{display: "flex", flexWrap: "wrap", gap: 8}}>
                {!loading && <ContentPageTile size="md" name={contentVersion.name} contentId={contentVersion.contentId} teamsiteId={contentVersion.teamsiteId} repository={contentVersion.repository} createdBy={contentVersion.createdBy} createdByEmail={contentVersion.createdByEmail} contentVersionId={selectedContentVersionId} page={selectedPage} version={contentVersion.version} createdAt={contentVersion.createdAt} thumbnailUrl={currentPage?.thumbnailUrl} />}
                {loading && <CenteredSpinner2 message="Finding similar content..." />}
                {similarContent.map((a, b)=> <ContentPageTile key={b} index={b} setShowModal={setShowThumbnailModal} setIndex={setIndex} size="md" {...a} />)}
            </div>}
            {/*
            <h3>Selected Content Slides</h3>
            {contentVersion && <div style={{display: "flex", flexWrap: "wrap", gap: 8}}>
                {contentVersion.pages.map(a=><ContentPageTile size="xs" name={contentVersion.name} contentVersionId={contentVersion.contentVersionId} page={a.page} distance={a.distance} version={contentVersion.version} createdAt={contentVersion.createdAt} thumbnailUrl={a.thumbnailUrl} />)}
            </div>}
            */}
        </div>
    </>;
}